import { CustomTag } from "../../../Tags";
import { TagColors } from "../../../Tags/utils/theme";

/**
 * 상품분류 enum
 */
export enum ProductCategoryStatus {
  TIRE = "타이어",
  WHEEL_ALIGNMENT = "휠얼라인먼트",
  ENGINE_OIL = "엔진오일",
  BRAKE_PAD = "브레이크패드",
  WIPER = "와이퍼",
  TIRE_STORAGE = "보관서비스",
}

/**
 * 상품분류 key type
 */
export type ProductCategoryStatusType = keyof typeof ProductCategoryStatus;

/**
 * 상품분류별 색상
 */
export const productCategoryStatusTypeColor: {
  [key: string]: TagColors;
} = {
  TIRE: "primary",
  WHEEL_ALIGNMENT: "primary",
  TIRE_STORAGE: "primary",
  ENGINE_OIL: "orange",
  BRAKE_PAD: "orange",
  WIPER: "blue",
};

/**
 * @TAG 배송
 * 배송 상품분류 enum
 */
export enum ProductDeliveryCategoryStatus {
  TIRE = "타이어",
  ENGINE_OIL = "엔진오일",
  WIPER = "와이퍼",
}

/**
 * @TAG 배송
 * 배송 상품분류 key type
 */
export type ProductDeliveryCategoryStatusType =
  keyof typeof ProductDeliveryCategoryStatus;

interface ProductCategoryStatusTagProps {
  value: ProductCategoryStatusType;
}

/**
 * 상품분류 태그
 * @param value
 * @returns
 */
export const ProductCategoryStatusTag: React.FC<
  ProductCategoryStatusTagProps
> = ({ value }) => {
  return (
    <>
      {ProductCategoryStatus[value] ? (
        <CustomTag colors={productCategoryStatusTypeColor[value]} ghost>
          {ProductCategoryStatus[value]}
        </CustomTag>
      ) : (
        "-"
      )}
    </>
  );
};
